export const JOBS_PARAM_KEYS = { category: "jobs_category", level: "jobs_level", early: "jobs_early", q: "jobs_q", workplace: "jobs_workplace", company: "jobs_company" };

export const FEATURED_EMPLOYERS = [
  { name: "NVIDIA", blurb: "AI compute & data center systems" },
  { name: "Microsoft", blurb: "Azure cloud infrastructure" },
  { name: "Google", blurb: "Hyperscale campuses worldwide" },
  { name: "Amazon", blurb: "AWS data centers" },
  { name: "Meta", blurb: "AI data centers", external: "https://www.metacareers.com/jobs?q=data%20center" },
  { name: "OpenAI", blurb: "Frontier compute infrastructure" },
  { name: "Oracle", blurb: "OCI cloud regions" },
  { name: "Equinix", blurb: "Global colocation & interconnection" },
];

export const jobsBoardUrl = ({ category, level, early, q, workplace, company } = {}) => {
  const params = new URLSearchParams();
  if (category) params.set(JOBS_PARAM_KEYS.category, category);
  if (level) params.set(JOBS_PARAM_KEYS.level, level);
  if (workplace) params.set(JOBS_PARAM_KEYS.workplace, workplace);
  if (company) params.set(JOBS_PARAM_KEYS.company, company);
  if (early) params.set(JOBS_PARAM_KEYS.early, "1");
  if (q) params.set(JOBS_PARAM_KEYS.q, q);
  const query = params.toString();
  return `/${query ? `?${query}` : ""}#jobs`;
};

export const filtersFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return {
    q: params.get(JOBS_PARAM_KEYS.q) || "",
    category: params.get(JOBS_PARAM_KEYS.category) || "all",
    workplace: params.get(JOBS_PARAM_KEYS.workplace) || "all",
    level: params.get(JOBS_PARAM_KEYS.level) || "all",
    company: params.get(JOBS_PARAM_KEYS.company) || "all",
    early_career: params.get(JOBS_PARAM_KEYS.early) === "1",
    page: 1,
  };
};

export const askBot = (prompt) => window.dispatchEvent(new CustomEvent("dcyb:open-chat", { detail: { prompt } }));

export const requestIntro = (preset = {}) => window.dispatchEvent(new CustomEvent("dcyb:request-intro", { detail: preset }));

export const daysSince = (value) => (value ? Math.floor((Date.now() - new Date(value).getTime()) / 86400000) : null);

export const STALE_AFTER_DAYS = 45;

export const relativeDate = (value) => {
  const days = daysSince(value);
  if (days === null) return null;
  if (days <= 0) return "today";
  if (days === 1) return "1 day ago";
  if (days < 30) return `${days} days ago`;
  const months = Math.floor(days / 30);
  return months === 1 ? "1 month ago" : `${months} months ago`;
};
